import { render } from "./SearchProperties.vue?vue&type=template&id=5a51399e&scoped=true"
import script from "./SearchProperties.vue?vue&type=script&lang=js"
export * from "./SearchProperties.vue?vue&type=script&lang=js"

import "./SearchProperties.vue?vue&type=style&index=0&id=5a51399e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a51399e"]])

export default __exports__